module.exports = __webpack_public_path__ + "media/images/top/ranking-sample02-6bc022b0821d1e5a205230eef72073ad.jpg";